import { useTheme } from '@emotion/react'
import { m } from 'framer-motion'

const borderVariants = {
	animating: {
		opacity: 1,
		pathLength: 0.05,
		pathSpacing: 0.015,
	},
	hidden: {
		opacity: 0,
	},
	initial: { opacity: 0, pathLength: 0, pathSpacing: 0.02 },
}

type Props = {
	showAnimation: boolean
}

function AnimatedBorder({ showAnimation }: Props) {
	const theme = useTheme()

	return (
		<svg width="145" height="56">
			<m.path
				width="140px"
				height="53px"
				d="M9.375,1.0952381 L133.375,1.0952381 C137.793278,1.0952381 141.375,4.6769601 141.375,9.0952381 L141.375,46.4285714 C141.375,50.8468494 137.793278,54.4285714 133.375,54.4285714 L9.375,54.4285714 C4.956722,54.4285714 1.375,50.8468494 1.375,46.4285714 L1.375,9.0952381 C1.375,4.6769601 4.956722,1.0952381 9.375,1.0952381 Z"
				fill="transparent"
				strokeWidth="2"
				stroke={theme.colors.light.border}
				strokeLinecap="round"
				strokeDasharray="1, 1"
				variants={borderVariants}
				initial={'initial'}
				animate={showAnimation ? 'animating' : 'hidden'}
				transition={{ duration: 2, ease: 'easeOut' }}
			/>
		</svg>
	)
}

export default AnimatedBorder
